import { ReactNode } from 'react'

import { WorkFileStatuses } from '../../../_generated/api/workfile-import'
import { Row } from './FlexContainer'
import PrimeIcon from './PrimeIcon'
import { getPropertyValue } from '../../../tools/dom/css-properties'
import t from '../../../tools/t'

const NEUTRAL_COLOR = '#555555'

interface ChipProps {
    label: string
    color?: string
    icon?: ReactNode
}

export function Chip({ label, color, icon }: ChipProps) {
    // Construct a hex alpha-component for the background to get a more transparent version of the given color.
    const hexOpacity = (50).toString(16)

    return (
        <Row
            className="chip"
            arrangement="start"
            alignment="center"
            gap={0.5}
            style={{ background: color + hexOpacity, color }}
        >
            {icon}
            {label}
        </Row>
    )
}

export const UploadingChip = () => (
    <Chip
        label={t('workfile_status_uploading')}
        color={NEUTRAL_COLOR}
        icon={<PrimeIcon name="sync" spin />}
    />
)

export const ReadyChip = () => (
    <Chip
        label={t('workfile_status_ready')}
        color={NEUTRAL_COLOR}
        icon={<PrimeIcon name="clock" />}
    />
)

export const ConflictChip = () => (
    <Chip
        label={t('workfile_status_conflict')}
        color={getPropertyValue('--danger-color')}
        icon={<PrimeIcon name="exclamation-circle" />}
    />
)

export const ProcessingChip = () => (
    <Chip
        label={t('workfile_status_processing')}
        color={getPropertyValue('--info-color')}
        icon={<PrimeIcon name="sync" spin />}
    />
)

export const ErrorChip = () => (
    <Chip
        label={t('workfile_status_error')}
        color={getPropertyValue('--danger-color')}
        icon={<PrimeIcon name="exclamation-circle" />}
    />
)

export const SuccessChip = () => (
    <Chip
        label={t('workfile_status_success')}
        color={getPropertyValue('--success-color')}
        icon={<PrimeIcon name="check-circle" />}
    />
)

export const UnknownChip = () => (
    <Chip
        label={t('workfile_status_unknown')}
        color={NEUTRAL_COLOR}
        icon={<PrimeIcon name="question-circle" />}
    />
)

interface StatusChipProps {
    status: WorkFileStatuses
}
export const StatusChip = ({ status }: StatusChipProps) => {
    switch (status) {
        case WorkFileStatuses.Uploading:
            return <UploadingChip />
        case WorkFileStatuses.ReadyForProcessing:
            return <ReadyChip />
        case WorkFileStatuses.Conflict:
            return <ConflictChip />
        case WorkFileStatuses.Processing:
            return <ProcessingChip />
        case WorkFileStatuses.Error:
            return <ErrorChip />
        case WorkFileStatuses.Success:
            return <SuccessChip />
        case WorkFileStatuses.Unknown:
        default:
            return <UnknownChip />
    }
}
